import VueI18n from 'vue-i18n'
import messages from '../../../translation/messages'
import _ from 'lodash'

export default (opts) => {
    const { messages: appMessages } = opts
    opts.messages = _.merge(messages, appMessages)

    return new VueI18n(opts)
}